import React, { useMemo } from "react"
import { Button, Text } from "@chakra-ui/react"
import { ProductVariant, SelectedOption, ProductOption } from "@shopify/hydrogen-react/storefront-api-types"

import Dropdown from "@app/components/Dropdown"
import Icon from "@app/components/Icon"

type Props = {
  option: ProductOption
  activeOptions: Array<SelectedOption>
  activeVariant: ProductVariant | null
  handleOption: (option: SelectedOption) => void
  noActiveOption: boolean
  disableNoActiveOption: (state: boolean) => void
}

export const ProductStockVariantsDropdown: React.FC<Props> = React.memo(
  ({ option, activeOptions, handleOption, noActiveOption, disableNoActiveOption, activeVariant }) => {
    const activeValue = useMemo(
      () => activeVariant?.selectedOptions?.[0]?.value || activeOptions?.find(activeOption => activeOption?.name === option?.name)?.value,
      [activeVariant?.selectedOptions, activeOptions, option?.name]
    )

    return (
      <Dropdown
        dropdownProps={{
          zIndex: 300,
          minW: "180px",
        }}
        renderButton={(open: boolean) => (
          <Button
            variant="dropdown"
            minW="200px"
            w="100%"
            borderBottomLeftRadius={open ? 0 : "21.6px"}
            borderBottomRightRadius={open ? 0 : "21.6px"}
            borderBottomColor={open ? "transparent" : "brand.darkBlue"}
            _active={{
              bgColor: open ? "brand.white" : "brand.darkBlue",
            }}
            _hover={{
              color: open ? "brand.darkBlue" : "brand.white",
              bgColor: open ? "brand.white" : "brand.darkBlue",
            }}
          >
            {activeValue || noActiveOption ? activeValue : "Please select"}
            <Icon name="chevronDownDropdown" width="10px" height="6px" />
          </Button>
        )}
        renderDropdown={onItemClick => (
          <>
            {option?.values?.map(value => (
              <Text
                key={value}
                as="button"
                px="22px"
                py="14px"
                display="block"
                w="full"
                textAlign="left"
                aria-label={value}
                title={value}
                fontSize={13.3333}
                borderBottom="1px solid"
                borderColor="#bbb"
                _first={{ borderTop: "1px solid #bbb" }}
                _last={{ borderBottom: "none" }}
                _hover={{
                  color: "primary.white",
                  bgColor: "brand.darkBlue",
                }}
                onClick={() => {
                  onItemClick(value)
                  disableNoActiveOption(true)
                }}
              >
                {value}
              </Text>
            ))}
          </>
        )}
        handleItemClick={value => handleOption?.({ name: option.name, value })}
      />
    )
  }
)
